import IUser from "../../models/IUser";

export interface IAuthState {
  ready: boolean;
  isAuthenticated: boolean;
  user?: IUser;
}

export const SIGN_IN = "AUTH_SIGN_IN";
export const SIGN_OUT = "AUTH_SIGN_OUT";

export type ActionTypes = typeof SIGN_IN | typeof SIGN_OUT;

export interface IAuthAction {
  type: ActionTypes;
  payload: IAuthState;
}
